import { useTranslation } from 'react-i18next'
import ConfirmDialog from '../ConfirmDialog'
import { useState } from 'react'
import { Button } from '@playbooks/ui/components/button'
import { RotateCw } from 'lucide-react'
import { useWebPlayContext } from '../../context/WebplayContext'
import { clearLocalData } from '../../services/storage'

export default function ResetButton() {
  const { t } = useTranslation()
  const { storageId } = useWebPlayContext()
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  const handleConfirmReset = async () => {
    setShowConfirmDialog(false)
    await clearLocalData(storageId)
    window.location.reload()
  }

  const handleCancelReset = () => {
    setShowConfirmDialog(false)
  }

  return (
    <>
      {showConfirmDialog && (
        <ConfirmDialog
          title={t('footer.reset_confirm_title', 'Reset Progress')}
          message={t(
            'footer.reset_confirm_message',
            'Are you sure you want to reset your progress? All your data will be cleared.',
          )}
          onConfirm={handleConfirmReset}
          onCancel={handleCancelReset}
          confirmText={t('footer.reset_confirm_button', 'Reset')}
          cancelText={t('footer.reset_cancel_button', 'Cancel')}
        />
      )}

      <Button
        type="button"
        data-testid="reset-button"
        className="border-secondary w-full max-w-max"
        onClick={() => setShowConfirmDialog(true)}
        variant="secondary"
      >
        <RotateCw size={16} />
        <div className="max-sm:truncate max-w-full">{t('footer.reset', 'Reset')}</div>
      </Button>
    </>
  )
}
